import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgTrashIconSecondary from './svgs/TrashIconSecondary.js';
import SvgTrashIcon from './svgs/TrashIcon.js';
import { useIcon } from '../../shared-components/icon/index.js';

var trashIcon = (props => useIcon(SvgTrashIcon, SvgTrashIconSecondary, props));

export { trashIcon as default };
